import React, { useState } from "react";
import { FaXmark } from "react-icons/fa6";

export default function DashboardFilterModal({
  closeModal,
  ObjectArray,
  handleUpdateFilterWithDashboardId,
  dashboardSheetID,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  // Filter the ObjectArray based on the search term
  const filteredItems = ObjectArray.filter((item) =>
    item.rename.toLowerCase().includes(searchTerm.toLowerCase())
  );
  console.log(filteredItems);
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      closeModal(); // Call your function here
    }
  };
  return (
    <main
      className="fixed inset-0 bg-gray-600 bg-opacity-50 flex flex-col items-center justify-center z-20"
      onKeyDown={handleKeyDown}
    >
      <main className="w-[25rem] h-auto bg-white shadow-2xl rounded-lg flex flex-col gap-2">
        <header className="flex bg-gray-50 w-full p-2 items-center justify-between rounded-t-lg">
          Set filters for sheet
          <button onClick={closeModal}>
            <FaXmark />
          </button>
        </header>
        <section className="w-full flex flex-col items-center justify-center gap-2 p-2">
          {/* Search input box */}
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search item"
            className="w-full p-1 border border-gray-300 rounded outline-none focus:ring-0"
          />

          {/* Render filtered items */}
          {filteredItems.map((item, index) => (
            <label
              key={index}
              className="flex items-center gap-2 w-full"
              onClick={() =>
                handleUpdateFilterWithDashboardId({
                  nanoId: item.nanoId,
                  dashIDs: dashboardSheetID,
                  removeAllSheetFilters: false,
                })
              }
            >
              <input
                type="checkbox"
                className="checkbox-input"
                checked={
                  Array.isArray(item.dashboardIDs) &&
                  item.dashboardIDs.includes(dashboardSheetID)
                }
              />
              <button className="text-[14px] hover:text-[#5ac189]">
                {item.rename}
              </button>
            </label>
          ))}
        </section>
        <footer className="flex w-full items-center justify-end gap-4 p-2">
          <button className="border w-20" onClick={closeModal}>
            Close
          </button>
          <button className="border w-20" onClick={closeModal}>
            Apply
          </button>
        </footer>
      </main>
    </main>
  );
}
